import { CreateAccountProvider } from "context/CreateAccountContext"
import { act, useState } from "react"
import styled from "styled-components"
import { Modal } from "ui/base/modal/Modal.jsx"
import { Otp } from "./Otp"
import { Signup } from "./Singup"
import { mediaSizes } from "ui/theme";

export const SignupModal = ({ show, handleClose, setLoginModal }) => {
    const [activeTab, setActiveTab] = useState("signup");

    return (
        <Modal show={show} handleClose={handleClose} maxWidth={450} widthPercentage={100}>
            <Container>
                <CreateAccountProvider>
                    <Tab active={activeTab === "signup"}>
                        <Signup
                            setActiveTab={setActiveTab}
                            setLoginModal={setLoginModal}
                            handleClose={handleClose}
                        />
                    </Tab>
                    <Tab active={activeTab === "otp"}>
                        <Otp setActiveTab={setActiveTab} handleClose={handleClose}  />
                    </Tab>
                </CreateAccountProvider>
            </Container>
        </Modal>
    )
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    gap: 1rem;
`

const Tab = styled.div`
    width: 100%;
    height: 100%;
    display: ${({ active }) => (active ? "flex" : "none")};
`
